
import myinput from '../common/myinput'
import {regionData} from 'element-china-area-data'
import InlineXSwitch from 'vux/src/components/inline-x-switch/index.vue'

import 'vue-awesome/icons/times'
import Icon from 'vue-awesome/components/Icon'

export default {
name: "address",
components:{
myinput,
InlineXSwitch,
'v-icon':Icon
},
data(){
let redata=regionData;
return {
test:'',
casedeData:[],
addressPicker:null,
address:[redata[0].label],
checked:false,
pickershow:false,
form:{
name:'',
phone:'',
address:'',
is_default:1
}
}
},
computed:{

},
mounted() {
this.addressPicker=this.$createCascadePicker({
data:this.casedeData,
onSelect:this.selectCity
})
},
methods:{
dataformat(data){
var tmp=[];
data.forEach((item)=>{
item.text=item.label;
if(item.hasOwnProperty('children')){
item.children=this.dataformat(item.children);
}
tmp.push(item);
})
return tmp;
},
selectCity(text,index=0){
this.$set(this.address,index,text);
},
addressAdd(){
this.axios.post('/xcx/User/addressAdd',this.form).then(res=>{
this.$router.go(-1);
})
},
addressEdit(){
this.axios.post('/xcx/User/addressEdit',this.form).then(res=>{
this.$router.go(-1);
})
},
submit(){
if(this.$route.query.type=='add'){
this.addressAdd();
}else if(this.$route.query.type=='edit'){
this.addressEdit();
}
}
},
created() {
this.casedeData=this.dataformat(regionData);
if(this.$route.query.type=='add'){
document.title='新增地址';
}else if(this.$route.query.type=='edit'){
if(!this.$route.params.addressdata){
this.$router.go(-1);
}
this.form={...this.form,...this.$route.params.addressdata};
}
}
}



// WEBPACK FOOTER //
// ./src/components/address/address.vue